import React, { memo, useMemo } from 'react';
import { TimeSignalDimensionType } from 'graphql/types';
import { useGetTimeSignalAnalyticsData } from 'modules/Insights/Notes/hooks/useGetTimeSignalAnalyticsData';
import { transformLabelData } from './utils';
import ClientComponent from './ClientComponent';

export const ClientChart: React.FC = () => {
  const { data, loading = true, isEmpty } = useGetTimeSignalAnalyticsData(
    TimeSignalDimensionType.MetricsByClient
  );

  const dataset = useMemo(() => {
    if (isEmpty) {
      return [];
    } else {
      return transformLabelData(data?.timeSignalAnalytics?.items, 'CLIENT');
    }
  }, [data?.timeSignalAnalytics?.items, isEmpty]);

  return <ClientComponent data={dataset} loading={loading} isEmpty={isEmpty} />;
};
export default memo(ClientChart);
